angular.module('unica_hospitality.hospitality_controllers', [])

.controller('HospitalityBasicController',
	function(
		$rootScope, $scope, $state,
		ROOM_OCCUPATIONS,
		HotelListService,
		TransferListService
	) {


	$scope.roomOccupations = ROOM_OCCUPATIONS;

	$scope.forms = {};

	$scope.hotelData = {
		name: '',
		address: '',
		latitude: '',
		longitude: '',
		route_description: ''
	};

	$scope.transferData = {
		name: '',
		note: ''
	};

	$scope.marker = null;

	$scope.map = {
		center: { latitude: 41.9099856, longitude: 12.3955726 },
		options: {
			streetViewControl: false,
			fullscreenControl: false,
			mapTypeControl: false
		},
		zoom: 7,
		events: {
			click: function (map, eventName, originalEventArgs) {
				var e = originalEventArgs[0];
				$scope.geocodePosition(e);
				var lat = e.latLng.lat(),
					lng = e.latLng.lng();
				$scope.marker = {
					id: Date.now(),
					coords: {
						latitude: lat,
						longitude: lng
					}
				};
				$scope.map.center = { latitude: lat, longitude: lng };
				$scope.$apply();
			}
		}
	};

	$scope.geocoding = false;

	if ( typeof google !== "undefined" ) {
		$scope.geocoder = new google.maps.Geocoder();
	}

	$scope.geocodePosition = function(event) {
		$scope.hotelData.latitude = event.latLng.lat();
		$scope.hotelData.longitude = event.latLng.lng();

		$scope.geocoding = true;
		$scope.geocoder.geocode({
			latLng: event.latLng
		}, function(responses) {

			$scope.geocoding = false;
			if (responses && responses.length > 0) {
				$scope.hotelData.address = responses[0].formatted_address;
			}

			$scope.$apply();
		});
	};

	$scope.lookupHotel = function() {
		$scope.geocoder.geocode({
			address: $scope.hotelData.address
		}, function(responses) {
			if (responses && responses.length > 0) {
				$scope.hotelData.latitude  = responses[0].geometry.location.lat();
				$scope.hotelData.longitude = responses[0].geometry.location.lng();

				$scope.marker = {
					id: Date.now(),
					coords: {
						latitude: $scope.hotelData.latitude,
						longitude: $scope.hotelData.longitude
					}
				};

				$scope.map.center = { latitude: $scope.hotelData.latitude, longitude: $scope.hotelData.longitude };
				$scope.map.zoom   = 16;

				$scope.$apply();
			}
		});
	};

	$scope.getHotel = function(hotelId) {
		$scope.showLoader();

		HotelListService
			.get(hotelId)
			.then(function(data) {
				$scope.hideLoader();

				$scope.hotelData = data;

				$scope.marker = {
					id: Date.now(),
					coords: {
						latitude: $scope.hotelData.latitude,
						longitude: $scope.hotelData.longitude
					}
				};

				$scope.map.center = { latitude: $scope.hotelData.latitude, longitude: $scope.hotelData.longitude };
			});
	};

	$scope.resetHotelData = function() {
		$scope.hotelData = {
			name: '',
			address: '',
			latitude: '',
			longitude: '',
			route_description: '',
			room_types: []
		};
	};

	$scope.getTransfer = function(transferId) {
		$scope.showLoader();

		TransferListService
			.get(transferId)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.transferData = data;
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.resetTransferData = function() {
		$scope.transferData = {
			name: '',
			note: ''
		};
	};

	$rootScope.invitationTransferData = {
		event_it: ''
	};

	$scope.parseInvitationTransferFromDateToTimestamp = function(invitationTransferData) {
		invitationTransferData.pick_up_date = moment( invitationTransferData.pick_up_date ).format('YYYY-MM-DD');
		invitationTransferData.pick_up_time = moment( invitationTransferData.pick_up_time ).format('HH:mm:ss');
		return invitationTransferData;
	};


	$scope.addRoomType = function() {
		if ( !$scope.hotelData.room_types )
			$scope.hotelData.room_types = [];
		$scope.hotelData.room_types.push('');
	};

	$scope.removeRoomType = function(index) {
		$scope.hotelData.room_types.splice(index, 1);
	};

	$scope.roomOccupationsLabels = {};
	angular.forEach( $rootScope.roomOccupations, function(el, index) {
		$scope.roomOccupationsLabels[index] = el;
	});

});

